import { sva } from "@filadd/phi-plus-styled-system/css";

export const infoCardRecipe = sva({
  slots: [
    "root",
    "image",
    "header",
    "title",
    "description",
    "actions",
    "footer",
  ],
  base: {
    root: {
      display: "flex",
      width: "full",
      gap: 6,
      p: { base: 5, md: 10 },
      alignItems: "center",
      textAlign: "center",
      boxShadow: "md",
    },
    image: {
      maxW: { base: "200px", md: "300px" },
    },
    header: {
      display: "flex",
      gap: 4,
      width: "full",
      maxW: "5xl",
      alignItems: "center",
      textAlign: "center",
      textStyle: { base: "bodyMedium", md: "bodyLarge" },
      fontWeight: { base: "normal", md: "semibold" },
    },
    title: {
      textStyle: { base: "titleMedium", md: "titleLarge" },
    },
    actions: {
      display: "flex",
      flexDir: "row",
      alignItems: "flex-end",
      justifyContent: "flex-end",
      gap: 2,
    },
  },
});
